interface IconProps {
  size?: number;
}

/** Gold coin glyph — the single source of truth for the coin icon shown in the
 *  HUD pill, the shop and every buy button. Keep shop/home visuals identical. */
export function CoinIcon({ size = 14 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      style={{ verticalAlign: 'middle', flexShrink: 0 }}
      aria-hidden
    >
      <circle cx="7" cy="7" r="6" fill="var(--c-yellow)" stroke="#a07c00" strokeWidth="1" />
      <circle cx="7" cy="7" r="3.5" fill="none" stroke="#a07c00" strokeWidth="1" />
    </svg>
  );
}

/** Faceted gem glyph — companion to {@link CoinIcon}. Brilliant-cut diamond:
 *  a lighter crown over a deeper pavilion with facet edges for sparkle. */
export function GemIcon({ size = 14 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      style={{ verticalAlign: 'middle', flexShrink: 0 }}
      aria-hidden
    >
      {/* crown (upper band, lighter) */}
      <polygon points="4,2 12,2 15,6 1,6" fill="#38bdf8" />
      {/* pavilion (lower, deeper) */}
      <polygon points="1,6 15,6 8,15" fill="#0ea5c4" />
      {/* table highlight */}
      <polygon points="4,2 8,2 6,6 2.2,6" fill="#bae6fd" opacity="0.6" />
      {/* outline + facet edges */}
      <g stroke="#0e7490" strokeWidth="0.9" strokeLinejoin="round" fill="none">
        <polygon points="4,2 12,2 15,6 8,15 1,6" />
        <path d="M1,6 H15 M4,2 6,6 M12,2 10,6 M8,2 V6 M6,6 8,15 M10,6 8,15" />
      </g>
    </svg>
  );
}
